export default __webpack_public_path__ + "static/media/arrival.00b3a988.jpg";